/* tslint:disable */
/* eslint-disable */
/**
 * Hisselab.ActionHub.Query
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Any
 */
export interface Any {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof Any
     */
    '@type': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ChartType = {
    ChartTypeUnspecified: 'chartTypeUnspecified',
    LineChart: 'lineChart',
    BarChart: 'barChart'
} as const;

export type ChartType = typeof ChartType[keyof typeof ChartType];


/**
 * 
 * @export
 * @interface Companies
 */
export interface Companies {
    /**
     * 
     * @type {string}
     * @memberof Companies
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Companies
     */
    'code'?: string;
    /**
     * 
     * @type {Name}
     * @memberof Companies
     */
    'companyName'?: Name;
}
/**
 * 
 * @export
 * @interface ContentReplay
 */
export interface ContentReplay {
    /**
     * 
     * @type {string}
     * @memberof ContentReplay
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContentReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface CurrencyReplay
 */
export interface CurrencyReplay {
    /**
     * 
     * @type {Array<CurrencyValue>}
     * @memberof CurrencyReplay
     */
    'items'?: Array<CurrencyValue>;
    /**
     * 
     * @type {string}
     * @memberof CurrencyReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface CurrencyValue
 */
export interface CurrencyValue {
    /**
     * 
     * @type {string}
     * @memberof CurrencyValue
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CurrencyValue
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CustomAnalysisReplay
 */
export interface CustomAnalysisReplay {
    /**
     * 
     * @type {Array<IndexList2>}
     * @memberof CustomAnalysisReplay
     */
    'indexes'?: Array<IndexList2>;
    /**
     * 
     * @type {string}
     * @memberof CustomAnalysisReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface Details
 */
export interface Details {
    /**
     * 
     * @type {string}
     * @memberof Details
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Details
     */
    'securityName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Details
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Details
     */
    'sector'?: string;
    /**
     * 
     * @type {number}
     * @memberof Details
     */
    'peerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Details
     */
    'peerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Details
     */
    'customSector'?: string;
}
/**
 * 
 * @export
 * @interface DetailsIndex
 */
export interface DetailsIndex {
    /**
     * 
     * @type {string}
     * @memberof DetailsIndex
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailsIndex
     */
    'Name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailsIndex
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface Dict
 */
export interface Dict {
    /**
     * 
     * @type {string}
     * @memberof Dict
     */
    'trTr'?: string;
    /**
     * 
     * @type {string}
     * @memberof Dict
     */
    'enUs'?: string;
}
/**
 * 
 * @export
 * @interface Dict2
 */
export interface Dict2 {
    /**
     * 
     * @type {string}
     * @memberof Dict2
     */
    'trTr'?: string;
    /**
     * 
     * @type {string}
     * @memberof Dict2
     */
    'enUs'?: string;
}
/**
 * 
 * @export
 * @interface IndexContentReplay
 */
export interface IndexContentReplay {
    /**
     * 
     * @type {string}
     * @memberof IndexContentReplay
     */
    'content'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexContentReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface IndexDetailReplay
 */
export interface IndexDetailReplay {
    /**
     * 
     * @type {Array<DetailsIndex>}
     * @memberof IndexDetailReplay
     */
    'detail'?: Array<DetailsIndex>;
    /**
     * 
     * @type {string}
     * @memberof IndexDetailReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface IndexList
 */
export interface IndexList {
    /**
     * 
     * @type {string}
     * @memberof IndexList
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexList
     */
    'code'?: string;
    /**
     * 
     * @type {Dict}
     * @memberof IndexList
     */
    'name'?: Dict;
}
/**
 * 
 * @export
 * @interface IndexList2
 */
export interface IndexList2 {
    /**
     * 
     * @type {string}
     * @memberof IndexList2
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof IndexList2
     */
    'code'?: string;
    /**
     * 
     * @type {Dict2}
     * @memberof IndexList2
     */
    'name'?: Dict2;
}
/**
 * 
 * @export
 * @interface IndexReplay
 */
export interface IndexReplay {
    /**
     * 
     * @type {Array<IndexList>}
     * @memberof IndexReplay
     */
    'indexes'?: Array<IndexList>;
    /**
     * 
     * @type {string}
     * @memberof IndexReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface Name
 */
export interface Name {
    /**
     * 
     * @type {string}
     * @memberof Name
     */
    'trTR'?: string;
    /**
     * 
     * @type {string}
     * @memberof Name
     */
    'enUS'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PageName = {
    StockIndexEffect: 'StockIndexEffect',
    PersonelScoring: 'PersonelScoring',
    StockFiltering: 'StockFiltering',
    DividendExpected: 'DividendExpected',
    DividendFiltering: 'DividendFiltering',
    DividendCalcCriterion: 'DividendCalcCriterion'
} as const;

export type PageName = typeof PageName[keyof typeof PageName];


/**
 * 
 * @export
 * @interface QuarterReplay
 */
export interface QuarterReplay {
    /**
     * 
     * @type {string}
     * @memberof QuarterReplay
     */
    'entityId'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof QuarterReplay
     */
    'quarters'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof QuarterReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface RatioScore
 */
export interface RatioScore {
    /**
     * 
     * @type {string}
     * @memberof RatioScore
     */
    'scoreCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof RatioScore
     */
    'scoreName'?: string;
    /**
     * 
     * @type {number}
     * @memberof RatioScore
     */
    'score'?: number;
    /**
     * 
     * @type {number}
     * @memberof RatioScore
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof RatioScore
     */
    'criterian'?: string;
    /**
     * 
     * @type {number}
     * @memberof RatioScore
     */
    'fieldId'?: number;
    /**
     * 
     * @type {ChartType}
     * @memberof RatioScore
     */
    'chartType'?: ChartType;
    /**
     * 
     * @type {boolean}
     * @memberof RatioScore
     */
    'reverse'?: boolean;
}


/**
 * 
 * @export
 * @interface RatioScoreReplay
 */
export interface RatioScoreReplay {
    /**
     * 
     * @type {Array<RatioScore>}
     * @memberof RatioScoreReplay
     */
    'Ratioscore'?: Array<RatioScore>;
    /**
     * 
     * @type {string}
     * @memberof RatioScoreReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface SectorReplay
 */
export interface SectorReplay {
    /**
     * 
     * @type {Array<SectorSnap>}
     * @memberof SectorReplay
     */
    'sectorSnap'?: Array<SectorSnap>;
    /**
     * 
     * @type {string}
     * @memberof SectorReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface SectorSnap
 */
export interface SectorSnap {
    /**
     * 
     * @type {string}
     * @memberof SectorSnap
     */
    'sectorId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SectorSnap
     */
    'sectorCode'?: string;
    /**
     * 
     * @type {Name}
     * @memberof SectorSnap
     */
    'sectorName'?: Name;
    /**
     * 
     * @type {Array<Companies>}
     * @memberof SectorSnap
     */
    'companies'?: Array<Companies>;
}
/**
 * 
 * @export
 * @interface Securities
 */
export interface Securities {
    /**
     * 
     * @type {string}
     * @memberof Securities
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Securities
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Securities
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface SecuritiesEntityIds
 */
export interface SecuritiesEntityIds {
    /**
     * 
     * @type {string}
     * @memberof SecuritiesEntityIds
     */
    'uniqueCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof SecuritiesEntityIds
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof SecuritiesEntityIds
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface SecuritiesReplay
 */
export interface SecuritiesReplay {
    /**
     * 
     * @type {Array<Securities>}
     * @memberof SecuritiesReplay
     */
    'securities'?: Array<Securities>;
    /**
     * 
     * @type {string}
     * @memberof SecuritiesReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface SecurityDetailReplay
 */
export interface SecurityDetailReplay {
    /**
     * 
     * @type {Array<Details>}
     * @memberof SecurityDetailReplay
     */
    'detail'?: Array<Details>;
    /**
     * 
     * @type {string}
     * @memberof SecurityDetailReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * 
     * @type {number}
     * @memberof Status
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    'message'?: string;
    /**
     * 
     * @type {Array<Any>}
     * @memberof Status
     */
    'details'?: Array<Any>;
}
/**
 * 
 * @export
 * @interface WatchList
 */
export interface WatchList {
    /**
     * 
     * @type {string}
     * @memberof WatchList
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof WatchList
     */
    'name'?: string;
    /**
     * 
     * @type {Array<SecuritiesEntityIds>}
     * @memberof WatchList
     */
    'securitiesEntityIds'?: Array<SecuritiesEntityIds>;
}
/**
 * 
 * @export
 * @interface WatchListAllSymbolsReplay
 */
export interface WatchListAllSymbolsReplay {
    /**
     * 
     * @type {Array<WatchList>}
     * @memberof WatchListAllSymbolsReplay
     */
    'watchlist'?: Array<WatchList>;
    /**
     * 
     * @type {string}
     * @memberof WatchListAllSymbolsReplay
     */
    'error'?: string;
}

/**
 * AttachmentApi - axios parameter creator
 * @export
 */
export const AttachmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentDownloadPdfGet: async (identityToken: string, entityId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('attachmentDownloadPdfGet', 'identityToken', identityToken)
            const localVarPath = `/attachment/download-pdf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityId !== undefined) {
                localVarQueryParameter['EntityId'] = entityId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} reportId 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentDownloadReportGet: async (reportId: string, identityToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('attachmentDownloadReportGet', 'reportId', reportId)
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('attachmentDownloadReportGet', 'identityToken', identityToken)
            const localVarPath = `/attachment/download-report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reportId !== undefined) {
                localVarQueryParameter['reportId'] = reportId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttachmentApi - functional programming interface
 * @export
 */
export const AttachmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AttachmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachmentDownloadPdfGet(identityToken: string, entityId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachmentDownloadPdfGet(identityToken, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} reportId 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async attachmentDownloadReportGet(reportId: string, identityToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.attachmentDownloadReportGet(reportId, identityToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AttachmentApi - factory interface
 * @export
 */
export const AttachmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AttachmentApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentDownloadPdfGet(identityToken: string, entityId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.attachmentDownloadPdfGet(identityToken, entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} reportId 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachmentDownloadReportGet(reportId: string, identityToken: string, options?: any): AxiosPromise<void> {
            return localVarFp.attachmentDownloadReportGet(reportId, identityToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AttachmentApi - object-oriented interface
 * @export
 * @class AttachmentApi
 * @extends {BaseAPI}
 */
export class AttachmentApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentApi
     */
    public attachmentDownloadPdfGet(identityToken: string, entityId?: string, options?: AxiosRequestConfig) {
        return AttachmentApiFp(this.configuration).attachmentDownloadPdfGet(identityToken, entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} reportId 
     * @param {string} identityToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentApi
     */
    public attachmentDownloadReportGet(reportId: string, identityToken: string, options?: AxiosRequestConfig) {
        return AttachmentApiFp(this.configuration).attachmentDownloadReportGet(reportId, identityToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContentServiceApi - axios parameter creator
 * @export
 */
export const ContentServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [culture] 
         * @param {number} [dataId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubContentGet: async (identityToken: string, entityId?: string, culture?: string, dataId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('actionhubContentGet', 'identityToken', identityToken)
            const localVarPath = `/actionhub/content`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (dataId !== undefined) {
                localVarQueryParameter['dataId'] = dataId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContentServiceApi - functional programming interface
 * @export
 */
export const ContentServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContentServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [culture] 
         * @param {number} [dataId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionhubContentGet(identityToken: string, entityId?: string, culture?: string, dataId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContentReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionhubContentGet(identityToken, entityId, culture, dataId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContentServiceApi - factory interface
 * @export
 */
export const ContentServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContentServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [culture] 
         * @param {number} [dataId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubContentGet(identityToken: string, entityId?: string, culture?: string, dataId?: number, options?: any): AxiosPromise<ContentReplay> {
            return localVarFp.actionhubContentGet(identityToken, entityId, culture, dataId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContentServiceApi - object-oriented interface
 * @export
 * @class ContentServiceApi
 * @extends {BaseAPI}
 */
export class ContentServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [entityId] 
     * @param {string} [culture] 
     * @param {number} [dataId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentServiceApi
     */
    public actionhubContentGet(identityToken: string, entityId?: string, culture?: string, dataId?: number, options?: AxiosRequestConfig) {
        return ContentServiceApiFp(this.configuration).actionhubContentGet(identityToken, entityId, culture, dataId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CurrencyServiceApi - axios parameter creator
 * @export
 */
export const CurrencyServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubCurrenciesGet: async (identityToken: string, culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('actionhubCurrenciesGet', 'identityToken', identityToken)
            const localVarPath = `/actionhub/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CurrencyServiceApi - functional programming interface
 * @export
 */
export const CurrencyServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CurrencyServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionhubCurrenciesGet(identityToken: string, culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrencyReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionhubCurrenciesGet(identityToken, culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CurrencyServiceApi - factory interface
 * @export
 */
export const CurrencyServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CurrencyServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubCurrenciesGet(identityToken: string, culture?: string, options?: any): AxiosPromise<CurrencyReplay> {
            return localVarFp.actionhubCurrenciesGet(identityToken, culture, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CurrencyServiceApi - object-oriented interface
 * @export
 * @class CurrencyServiceApi
 * @extends {BaseAPI}
 */
export class CurrencyServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrencyServiceApi
     */
    public actionhubCurrenciesGet(identityToken: string, culture?: string, options?: AxiosRequestConfig) {
        return CurrencyServiceApiFp(this.configuration).actionhubCurrenciesGet(identityToken, culture, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomAnalysisServiceApi - axios parameter creator
 * @export
 */
export const CustomAnalysisServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubCustomanalysisindexesGet: async (identityToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('actionhubCustomanalysisindexesGet', 'identityToken', identityToken)
            const localVarPath = `/actionhub/customanalysisindexes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomAnalysisServiceApi - functional programming interface
 * @export
 */
export const CustomAnalysisServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomAnalysisServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionhubCustomanalysisindexesGet(identityToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomAnalysisReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionhubCustomanalysisindexesGet(identityToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomAnalysisServiceApi - factory interface
 * @export
 */
export const CustomAnalysisServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomAnalysisServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubCustomanalysisindexesGet(identityToken: string, options?: any): AxiosPromise<CustomAnalysisReplay> {
            return localVarFp.actionhubCustomanalysisindexesGet(identityToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomAnalysisServiceApi - object-oriented interface
 * @export
 * @class CustomAnalysisServiceApi
 * @extends {BaseAPI}
 */
export class CustomAnalysisServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAnalysisServiceApi
     */
    public actionhubCustomanalysisindexesGet(identityToken: string, options?: AxiosRequestConfig) {
        return CustomAnalysisServiceApiFp(this.configuration).actionhubCustomanalysisindexesGet(identityToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IndexContentServiceApi - axios parameter creator
 * @export
 */
export const IndexContentServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [culture] 
         * @param {number} [dataId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubIndexcontentGet: async (identityToken: string, entityId?: string, culture?: string, dataId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('actionhubIndexcontentGet', 'identityToken', identityToken)
            const localVarPath = `/actionhub/indexcontent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (dataId !== undefined) {
                localVarQueryParameter['dataId'] = dataId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IndexContentServiceApi - functional programming interface
 * @export
 */
export const IndexContentServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IndexContentServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [culture] 
         * @param {number} [dataId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionhubIndexcontentGet(identityToken: string, entityId?: string, culture?: string, dataId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndexContentReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionhubIndexcontentGet(identityToken, entityId, culture, dataId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IndexContentServiceApi - factory interface
 * @export
 */
export const IndexContentServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IndexContentServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [culture] 
         * @param {number} [dataId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubIndexcontentGet(identityToken: string, entityId?: string, culture?: string, dataId?: number, options?: any): AxiosPromise<IndexContentReplay> {
            return localVarFp.actionhubIndexcontentGet(identityToken, entityId, culture, dataId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IndexContentServiceApi - object-oriented interface
 * @export
 * @class IndexContentServiceApi
 * @extends {BaseAPI}
 */
export class IndexContentServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [entityId] 
     * @param {string} [culture] 
     * @param {number} [dataId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndexContentServiceApi
     */
    public actionhubIndexcontentGet(identityToken: string, entityId?: string, culture?: string, dataId?: number, options?: AxiosRequestConfig) {
        return IndexContentServiceApiFp(this.configuration).actionhubIndexcontentGet(identityToken, entityId, culture, dataId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IndexServiceApi - axios parameter creator
 * @export
 */
export const IndexServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {PageName} [pagename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubCustomindexesGet: async (identityToken: string, pagename?: PageName, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('actionhubCustomindexesGet', 'identityToken', identityToken)
            const localVarPath = `/actionhub/customindexes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pagename !== undefined) {
                localVarQueryParameter['pagename'] = pagename;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubIndexGet: async (identityToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('actionhubIndexGet', 'identityToken', identityToken)
            const localVarPath = `/actionhub/index`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IndexServiceApi - functional programming interface
 * @export
 */
export const IndexServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IndexServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {PageName} [pagename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionhubCustomindexesGet(identityToken: string, pagename?: PageName, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndexReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionhubCustomindexesGet(identityToken, pagename, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionhubIndexGet(identityToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndexReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionhubIndexGet(identityToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IndexServiceApi - factory interface
 * @export
 */
export const IndexServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IndexServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {PageName} [pagename] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubCustomindexesGet(identityToken: string, pagename?: PageName, options?: any): AxiosPromise<IndexReplay> {
            return localVarFp.actionhubCustomindexesGet(identityToken, pagename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubIndexGet(identityToken: string, options?: any): AxiosPromise<IndexReplay> {
            return localVarFp.actionhubIndexGet(identityToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IndexServiceApi - object-oriented interface
 * @export
 * @class IndexServiceApi
 * @extends {BaseAPI}
 */
export class IndexServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {PageName} [pagename] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndexServiceApi
     */
    public actionhubCustomindexesGet(identityToken: string, pagename?: PageName, options?: AxiosRequestConfig) {
        return IndexServiceApiFp(this.configuration).actionhubCustomindexesGet(identityToken, pagename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndexServiceApi
     */
    public actionhubIndexGet(identityToken: string, options?: AxiosRequestConfig) {
        return IndexServiceApiFp(this.configuration).actionhubIndexGet(identityToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuarterServiceApi - axios parameter creator
 * @export
 */
export const QuarterServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubQuarterGet: async (identityToken: string, entityId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('actionhubQuarterGet', 'identityToken', identityToken)
            const localVarPath = `/actionhub/quarter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuarterServiceApi - functional programming interface
 * @export
 */
export const QuarterServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuarterServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionhubQuarterGet(identityToken: string, entityId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuarterReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionhubQuarterGet(identityToken, entityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * QuarterServiceApi - factory interface
 * @export
 */
export const QuarterServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuarterServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubQuarterGet(identityToken: string, entityId?: string, options?: any): AxiosPromise<QuarterReplay> {
            return localVarFp.actionhubQuarterGet(identityToken, entityId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuarterServiceApi - object-oriented interface
 * @export
 * @class QuarterServiceApi
 * @extends {BaseAPI}
 */
export class QuarterServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [entityId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuarterServiceApi
     */
    public actionhubQuarterGet(identityToken: string, entityId?: string, options?: AxiosRequestConfig) {
        return QuarterServiceApiFp(this.configuration).actionhubQuarterGet(identityToken, entityId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RatioScoreServiceApi - axios parameter creator
 * @export
 */
export const RatioScoreServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreRatioScoreGet: async (identityToken: string, entityId?: string, culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('scoreRatioScoreGet', 'identityToken', identityToken)
            const localVarPath = `/Score/RatioScore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RatioScoreServiceApi - functional programming interface
 * @export
 */
export const RatioScoreServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RatioScoreServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scoreRatioScoreGet(identityToken: string, entityId?: string, culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RatioScoreReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scoreRatioScoreGet(identityToken, entityId, culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RatioScoreServiceApi - factory interface
 * @export
 */
export const RatioScoreServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RatioScoreServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreRatioScoreGet(identityToken: string, entityId?: string, culture?: string, options?: any): AxiosPromise<RatioScoreReplay> {
            return localVarFp.scoreRatioScoreGet(identityToken, entityId, culture, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RatioScoreServiceApi - object-oriented interface
 * @export
 * @class RatioScoreServiceApi
 * @extends {BaseAPI}
 */
export class RatioScoreServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [entityId] 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatioScoreServiceApi
     */
    public scoreRatioScoreGet(identityToken: string, entityId?: string, culture?: string, options?: AxiosRequestConfig) {
        return RatioScoreServiceApiFp(this.configuration).scoreRatioScoreGet(identityToken, entityId, culture, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SectorServiceApi - axios parameter creator
 * @export
 */
export const SectorServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubSectorGet: async (identityToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('actionhubSectorGet', 'identityToken', identityToken)
            const localVarPath = `/actionhub/sector`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SectorServiceApi - functional programming interface
 * @export
 */
export const SectorServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SectorServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionhubSectorGet(identityToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SectorReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionhubSectorGet(identityToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SectorServiceApi - factory interface
 * @export
 */
export const SectorServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SectorServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubSectorGet(identityToken: string, options?: any): AxiosPromise<SectorReplay> {
            return localVarFp.actionhubSectorGet(identityToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SectorServiceApi - object-oriented interface
 * @export
 * @class SectorServiceApi
 * @extends {BaseAPI}
 */
export class SectorServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectorServiceApi
     */
    public actionhubSectorGet(identityToken: string, options?: AxiosRequestConfig) {
        return SectorServiceApiFp(this.configuration).actionhubSectorGet(identityToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SecuritiesServiceApi - axios parameter creator
 * @export
 */
export const SecuritiesServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubSecuritiesGet: async (identityToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('actionhubSecuritiesGet', 'identityToken', identityToken)
            const localVarPath = `/actionhub/securities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecuritiesServiceApi - functional programming interface
 * @export
 */
export const SecuritiesServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SecuritiesServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionhubSecuritiesGet(identityToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecuritiesReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionhubSecuritiesGet(identityToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SecuritiesServiceApi - factory interface
 * @export
 */
export const SecuritiesServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SecuritiesServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubSecuritiesGet(identityToken: string, options?: any): AxiosPromise<SecuritiesReplay> {
            return localVarFp.actionhubSecuritiesGet(identityToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SecuritiesServiceApi - object-oriented interface
 * @export
 * @class SecuritiesServiceApi
 * @extends {BaseAPI}
 */
export class SecuritiesServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecuritiesServiceApi
     */
    public actionhubSecuritiesGet(identityToken: string, options?: AxiosRequestConfig) {
        return SecuritiesServiceApiFp(this.configuration).actionhubSecuritiesGet(identityToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SecurityDetailServiceApi - axios parameter creator
 * @export
 */
export const SecurityDetailServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubIndexdetailGet: async (identityToken: string, entityId?: string, culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('actionhubIndexdetailGet', 'identityToken', identityToken)
            const localVarPath = `/actionhub/indexdetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubSecuritydetailGet: async (identityToken: string, entityId?: string, culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('actionhubSecuritydetailGet', 'identityToken', identityToken)
            const localVarPath = `/actionhub/securitydetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SecurityDetailServiceApi - functional programming interface
 * @export
 */
export const SecurityDetailServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SecurityDetailServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionhubIndexdetailGet(identityToken: string, entityId?: string, culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndexDetailReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionhubIndexdetailGet(identityToken, entityId, culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionhubSecuritydetailGet(identityToken: string, entityId?: string, culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SecurityDetailReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionhubSecuritydetailGet(identityToken, entityId, culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SecurityDetailServiceApi - factory interface
 * @export
 */
export const SecurityDetailServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SecurityDetailServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubIndexdetailGet(identityToken: string, entityId?: string, culture?: string, options?: any): AxiosPromise<IndexDetailReplay> {
            return localVarFp.actionhubIndexdetailGet(identityToken, entityId, culture, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entityId] 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubSecuritydetailGet(identityToken: string, entityId?: string, culture?: string, options?: any): AxiosPromise<SecurityDetailReplay> {
            return localVarFp.actionhubSecuritydetailGet(identityToken, entityId, culture, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SecurityDetailServiceApi - object-oriented interface
 * @export
 * @class SecurityDetailServiceApi
 * @extends {BaseAPI}
 */
export class SecurityDetailServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [entityId] 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityDetailServiceApi
     */
    public actionhubIndexdetailGet(identityToken: string, entityId?: string, culture?: string, options?: AxiosRequestConfig) {
        return SecurityDetailServiceApiFp(this.configuration).actionhubIndexdetailGet(identityToken, entityId, culture, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [entityId] 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityDetailServiceApi
     */
    public actionhubSecuritydetailGet(identityToken: string, entityId?: string, culture?: string, options?: AxiosRequestConfig) {
        return SecurityDetailServiceApiFp(this.configuration).actionhubSecuritydetailGet(identityToken, entityId, culture, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WatchListAllSymbolsServiceApi - axios parameter creator
 * @export
 */
export const WatchListAllSymbolsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubWatchlistallsymbolsGet: async (identityToken: string, culture?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('actionhubWatchlistallsymbolsGet', 'identityToken', identityToken)
            const localVarPath = `/actionhub/watchlistallsymbols`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (culture !== undefined) {
                localVarQueryParameter['culture'] = culture;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WatchListAllSymbolsServiceApi - functional programming interface
 * @export
 */
export const WatchListAllSymbolsServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WatchListAllSymbolsServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actionhubWatchlistallsymbolsGet(identityToken: string, culture?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WatchListAllSymbolsReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actionhubWatchlistallsymbolsGet(identityToken, culture, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WatchListAllSymbolsServiceApi - factory interface
 * @export
 */
export const WatchListAllSymbolsServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WatchListAllSymbolsServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [culture] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actionhubWatchlistallsymbolsGet(identityToken: string, culture?: string, options?: any): AxiosPromise<WatchListAllSymbolsReplay> {
            return localVarFp.actionhubWatchlistallsymbolsGet(identityToken, culture, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WatchListAllSymbolsServiceApi - object-oriented interface
 * @export
 * @class WatchListAllSymbolsServiceApi
 * @extends {BaseAPI}
 */
export class WatchListAllSymbolsServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [culture] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchListAllSymbolsServiceApi
     */
    public actionhubWatchlistallsymbolsGet(identityToken: string, culture?: string, options?: AxiosRequestConfig) {
        return WatchListAllSymbolsServiceApiFp(this.configuration).actionhubWatchlistallsymbolsGet(identityToken, culture, options).then((request) => request(this.axios, this.basePath));
    }
}



